import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CmsConfig,
  I18nModule, provideConfig,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core';
import { UigCartSharedModule } from '../uig-cart-shared/uig-cart-shared.module';
import { UigShippingNoteModule } from '../uig-shipping-note/uig-shipping-note.module';
import { UigCartTotalsComponent } from './uig-cart-totals.component';
import {CartCouponModule} from '@spartacus/cart/base/components';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    UigCartSharedModule,
    UigShippingNoteModule,
    I18nModule,
    CartCouponModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartTotalsComponent: {
          component: UigCartTotalsComponent,
        },
      },
    }),
  ],
  declarations: [UigCartTotalsComponent],
  exports: [UigCartTotalsComponent],
})
export class UigCartTotalsModule { }
